"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _SocialButtons = _interopRequireDefault(require("./SocialButtons"));

var _getUrlParam = require("@jobmatchme/utils/es/getUrlParam");

var _Pc = require("@jobmatchme/amplify-tools/es/provider/Pc");

var _ConfigProvider = require("../../provider/ConfigProvider");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SocialLogin = function SocialLogin(_ref) {
  var onLogin = _ref.onLogin,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;

  var _useContext = (0, _react.useContext)(_ConfigProvider.ConfigurationContext),
      config = _useContext.config;

  var _useAmplifyUser = (0, _Pc.useAmplifyUser)(),
      isAuthenticated = _useAmplifyUser.isAuthenticated;

  (0, _react.useEffect)(function () {
    if (isAuthenticated && onLogin) {
      onLogin();
    }
  }, [isAuthenticated, onLogin]);
  var customState = config.discriminator; // Grab parameters for direct like if any

  var jobId = (0, _getUrlParam.getUrlParam)('jobId', false);
  var jobRevision = (0, _getUrlParam.getUrlParam)('jobRevision', false);

  if (jobId && jobRevision) {
    customState = "".concat(customState, "|").concat(jobId, "|").concat(jobRevision);
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialButtons.default, {
    customState: customState,
    onClick: onClick,
    variant: variant
  });
};

var _default = SocialLogin;
exports.default = _default;